import { addDoc, collection, deleteDoc, doc, getDocs, Timestamp, updateDoc } from "firebase/firestore";
import { db, storage } from "./firebase";
import { deleteObject, getDownloadURL, ref, uploadBytes } from "firebase/storage";


export const addNews = async ({ title, description, link, img, hidden, pinned, date }) => {
    let id = "";
    try {
        const jsDate = date ? new Date(date) : new Date();
        const timestampDate = Timestamp.fromDate(jsDate);

        // ✅ Use correct collection name "news"
        const docRef = await addDoc(collection(db, "news"), {
            title,
            description,
            link,
            hidden,
            pinned,
            date: timestampDate,
            timestamp: Timestamp.now(),
            url: "", // will be updated after image upload
        });

        id = docRef.id;

        // Upload image
        const storageRef = ref(storage, `news/${id}`);
        await uploadBytes(storageRef, img);

        // Get download URL
        const url = await getDownloadURL(storageRef);

        // Update document with image URL
        await updateDoc(docRef, { url });

        console.log("News document created:", id);
        return id;
    } catch (error) {
        console.error("Error adding news data:", error);

        // Cleanup Firestore if image upload fails
        if (id) {
            await deleteDoc(doc(db, "news", id));
            console.warn("Firestore document deleted due to image upload failure.");
        }

        throw error;
    }
};

export const updateNewsFirestore = async ({ id, title, description, link, hidden, pinned, date }) => {
    if (!id) throw new Error("Document ID is required for updating news.");

    try {
        const updateData = {
            title,
            description,
            link,
            hidden,
            pinned,
            date: date ? Timestamp.fromDate(new Date(date)) : Timestamp.now(),
            timestamp: Timestamp.now()
        };

        const docRef = doc(db, "news", id);
        await updateDoc(docRef, updateData);

        console.log(`News document with ID ${id} updated successfully.`);
    } catch (error) {
        console.error("Error updating news document:", error);
        throw error;
    }
};

export const updateNewsImage = async ({ id, img }) => {
    if (!id || !img) {
        throw new Error("Both document ID and image file are required.");
    }

    try {
        // 1. Define storage path: news/{id}
        const storageRef = ref(storage, `news/${id}`);

        // 2. Upload the new image (overwrites existing one)
        await uploadBytes(storageRef, img);

        // 3. Get new download URL
        const url = await getDownloadURL(storageRef);

        // 4. Update Firestore with new URL
        const docRef = doc(db, "news", id);
        await updateDoc(docRef, { url });

        console.log(`News image for document ${id} updated successfully.`);
        return url;
    } catch (error) {
        console.error("Error updating news image:", error);
        throw error;
    }
};

export const fetchNews = async (setData) => {
    try {
        const querySnapshot = await getDocs(collection(db, "news"));
        const dataArr = [];

        querySnapshot.forEach((docSnap) => {
            const data = docSnap.data();
            const id = docSnap.id;
            let dateStr = "";
            if (data.date?.toDate) {
                dateStr = data.date.toDate().toISOString().slice(0, 10);
            }
            dataArr.push({ id, ...data, date: dateStr,  });
        });
        setData(dataArr);
    } catch (e) {
        console.error("Firebase Error in fetchNews:", e);
    }
};

export const deleteNews = async (id) => {
    try {
        await deleteDoc(doc(db, "news", id));
        console.log(`Document with id ${id} deleted successfully`);
        const storageRef = ref(storage, `news/${id}`);
        await deleteObject(storageRef)
            .then(() => console.log(`Image for id ${id} deleted from Storage`))
            .catch((err) => {
                if (err.code === "storage/object-not-found") {
                    console.warn(`No image found for id ${id}, skipping delete`);
                } else {
                    throw err; // rethrow other errors
                }
            });
        alert("News deleted successfully!");
    } catch (err) {
        console.error("Error deleting document:", err);
        alert("Failed to delete news.");
    }
};